import React, { useCallback, useEffect, useState } from "react";
import Link from "next/link";
import Article from "./Article";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

const AccueilNews: React.FC<any> = ({ articles }) => {
  const [emblaRef, embla] = useEmblaCarousel({ skipSnaps: false, loop: false }, [Autoplay({ delay: 8000 })]);
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  const scrollTo = useCallback((index) => embla && embla.scrollTo(index), [embla]);

  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
    setPrevBtnEnabled(embla.canScrollPrev());
    setNextBtnEnabled(embla.canScrollNext());
  }, [embla, setSelectedIndex]);

  useEffect(() => {
    if (!embla) return;
    onSelect();
    setScrollSnaps(embla.scrollSnapList());
    embla.on("select", onSelect);
  }, [embla, setScrollSnaps, onSelect]);

  return (
    <div className="container-padding container flex flex-col py-28 text-whiteAccent lg:py-36">
      <div className="flex flex-row items-center justify-between">
        <h2 className="mb-4">News</h2>
      </div>

      <div className="embla">
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container">
            {articles.map((article, key) => {
              try {
                if (article.fields) {
                  const titre: string = article.fields.titre;
                  const description: string = article.fields.description;
                  const date: string = article.fields.date;
                  const picUrl = article.fields.couverture?.fields ? article.fields.couverture.fields.file.url : undefined;
                  const slug: string = article.fields.slug;

                  return <Article key={key} titre={titre} description={description} date={date} pic={picUrl} slug={slug} />;
                }
              } catch (ex) {
                throw new Error(`Error while fetching news : ${ex}`);
              }
            })}
          </div>
        </div>
        <div className="embla__dots mt-4 flex items-center justify-center">
          {scrollSnaps.map((_, index) => (
            <DotButton key={index} selected={index === selectedIndex} onClick={() => scrollTo(index)} />
          ))}
        </div>
      </div>

      <div className="flex justify-end">
        <Link href="/news" passHref>
          <a
            aria-label="Aller sur la page des news"
            className="group mt-4 inline-flex items-center text-xs font-semibold uppercase tracking-wider text-redAccent"
          >
            Voir plus de news
            <svg
              className="ml-2 inline-block w-3 transform transition duration-500 ease-in-out group-hover:translate-x-1 group-focus:translate-x-1"
              fill="currentColor"
              viewBox="0 0 12 12"
            >
              <path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z" />
            </svg>
          </a>
        </Link>
      </div>
    </div>
  );
};

export default AccueilNews;

const DotButton = ({ selected, onClick }) => (
  <button
    className={`embla__dot mx-2 h-2 flex-1 rounded ${
      selected ? "is-selected bg-redAccent opacity-90 hover:cursor-default" : "bg-whiteAccent opacity-30 transition duration-300 hover:opacity-50"
    }`}
    type="button"
    onClick={onClick}
  />
);

// export const PrevButton = ({ enabled, onClick }) => (
//   <button className={`embla__prev ${enabled ? "text-redAccent" : "text-whiteAccent opacity-50"}`} onClick={onClick} disabled={!enabled}>
//     <svg className="h-6 w-6" fill="currentColor" rotate={180} viewBox="0 0 24 24">
//       <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
//     </svg>
//   </button>
// );

// export const NextButton = ({ enabled, onClick }) => (
//   <button className={`embla__next ${enabled ? "text-redAccent" : "text-whiteAccent opacity-50"}`} onClick={onClick} disabled={!enabled}>
//     <svg className="h-6 w-6" fill="currentColor" rotate={180} viewBox="0 0 24 24">
//       <path d="M6.028 0v6.425l5.549 5.575-5.549 5.575v6.425l11.944-12z" />{" "}
//     </svg>
//   </button>
// );
